import { Modal, Form, Input, Button } from "antd";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useState } from "react";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "list",
  "bullet",
  "link",
];

const AddTemplateModal = ({ visible, onCancel, onSave, isSending }) => {
  const [form] = Form.useForm();
  const [content, setContent] = useState("");

  const handleSubmit = async () => {
    try {
      const title = form.getFieldValue("title");
      if (!title) throw new Error("Title is required");
      if (!content || content === "<p><br></p>") throw new Error("Content is required");

      const success = await onSave({
        title,
        description: content,
        position: 0, // Will be updated by parent
      });

      if (success) {
        form.resetFields();
        setContent("");
        onCancel();
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Modal
      title="Add New Template"
      open={visible}
      onCancel={onCancel}
      width={800}
      footer={[
        <Button key="back" onClick={onCancel}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={handleSubmit}
          loading={isSending}
        >
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="title"
          label="Title"
          rules={[{ required: true, message: "Please input the title!" }]}
        >
          <Input placeholder="Enter title" />
        </Form.Item>

        <div style={{ marginBottom: "16px", background: "#f5f5f5", padding: "16px", borderRadius: "8px" }}>
        <strong>Available Variables:</strong>
        <p style={{ marginTop: "8px" }}>
          You can use the following placeholders in your content:
        </p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
          {[
            "{{orderId}}", "{{name}}", "{{username}}", "{{address}}", "{{postCode}}",
            "{{shippingDate}}", "{{trackingNumber}}", "{{carrier}}", "{{questions}}",
            "{{productName}}", "{{productLink}}"
          ].map((key) => (
            <span key={key} style={{ background: "#e6f7ff", padding: "4px 8px", borderRadius: "4px", fontFamily: "monospace" }}>
              {key}
            </span>
          ))}
        </div>
      </div>

        <Form.Item
          label="Content"
          required
          validateStatus={!content || content === "<p><br></p>" ? "error" : ""}
          help={!content || content === "<p><br></p>" ? "Please input the content!" : ""}
        >
          <ReactQuill
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            formats={formats}
            placeholder="Enter content..."
            style={{ height: "300px", marginBottom: "40px" }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default AddTemplateModal;